/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Network_Type_ConstantInputs */



/**
* | output |
* | --- |
* | "Constant temperature" |
*
* @param {Heating_Network_Type_ConstantInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_network_type_constant = /** @type {((inputs?: Heating_Network_Type_ConstantInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Network_Type_ConstantInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Constant temperature")
	return /** @type {LocalizedString} */ ("Température constante")
});